import * as React from "react";
import type { SVGProps } from "react";
const SvgCloudBackup = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M16.21 15.776h-.584C6.996 15.776 0 22.691 0 31.283 0 39.846 6.968 46.79 15.626 46.79h31.778c8.63 0 15.626-6.915 15.626-15.507-.058-8.592-7.026-15.536-15.684-15.536h-.583C45.334 8.688 39.037 3.394 31.486 3.394c-7.55 0-13.848 5.294-15.277 12.382ZM61.332 31.29c-.003 7.638-6.224 13.804-13.93 13.804H15.627c-7.731 0-13.929-6.194-13.929-13.81 0-7.64 6.223-13.81 13.93-13.81h1.972l.274-1.361C19.143 9.813 24.744 5.09 31.486 5.09c6.743 0 12.345 4.725 13.613 10.993l.276 1.36h1.97c7.726 0 13.933 6.19 13.988 13.845Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M64 45.576c0 8.3-6.73 15.03-15.03 15.03-8.301 0-15.03-6.73-15.03-15.03 0-8.301 6.729-15.03 15.03-15.03 8.3 0 15.03 6.729 15.03 15.03Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M48.97 58.909c7.364 0 13.333-5.97 13.333-13.333 0-7.364-5.97-13.334-13.333-13.334-7.364 0-13.334 5.97-13.334 13.334s5.97 13.333 13.334 13.333Zm0 1.697c8.3 0 15.03-6.73 15.03-15.03 0-8.301-6.73-15.03-15.03-15.03-8.301 0-15.03 6.729-15.03 15.03 0 8.3 6.729 15.03 15.03 15.03Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M40.727 45.212c.469 0 .849.38.849.849a7.879 7.879 0 1 0 15.758 0h1.696a9.576 9.576 0 0 1-9.575 9.576 9.576 9.576 0 0 1-9.576-9.576c0-.469.38-.849.848-.849Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M57.333 46.06a7.879 7.879 0 0 0-7.878-7.878.849.849 0 0 1 0-1.697 9.576 9.576 0 0 1 9.575 9.575h-1.697ZM40.127 43.522a.848.848 0 0 1 1.2 0l1.94 1.939a.849.849 0 0 1-1.2 1.2l-1.34-1.34-1.34 1.34a.848.848 0 1 1-1.199-1.2l1.94-1.94Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCloudBackup;
